import request from '@/utils/request'
  // 运单数据返回
  export function orderList(data) {

    return request({
      url: 'waybill/getData?_ajax=1',
      method: 'post',
      data: data
    })
  }

  // 中转公司数据返回
  export function transferStationInfo(data) {
    return request({
      url: 'waybill/transferStationInfo?_ajax=1',
      method: 'post',
      data: data
    })
  }

  // 运单轨迹数据返回
  export function orderTrackInfo(data) {
    return request({
      url: 'waybill/waybillTrack?_ajax=1',
      method: 'post',
      data: data
    })
  }

  // 运单信息返回
  export function orderInfo(data) {
    return request({
      url: 'waybill/waybillInfo?_ajax=1',
      method: 'post',
      data: data
    })
  }

  // 运单图片数据返回
  export function orderImages(data) {
    return request({
      url: 'Order_Archive/orderImages?_ajax=1',
      method: 'post',
      data: data
    })
  }

  // 运单客户对账
  export function orderCheck(data) {
    return request({
      url: 'Order_Archive/orderCheck?_ajax=1',
      method: 'post',
      data: data
    })
  }

